export const PublicIcon = ({ className }: { className?: string }) => {
    return (
        <svg
            width="51"
            height="50"
            viewBox="0 0 51 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect
                x="51"
                y="25"
                width="24"
                height="44"
                rx="4"
                transform="rotate(90 51 25)"
                fill="#D9D9D9"
            />
            <path
                d="M29.1668 43.7507V37.5007C29.1668 36.3956 28.7278 35.3358 27.9464 34.5544C27.165 33.773 26.1052 33.334 25.0002 33.334C23.8951 33.334 22.8353 33.773 22.0539 34.5544C21.2725 35.3358 20.8335 36.3956 20.8335 37.5007V43.7507"
                stroke="#A1A1AA"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.33317 20.834H12.4998H37.4998V14.584H41.6665C42.7716 14.584 43.8314 15.023 44.6128 15.8044C45.3942 16.5858 45.8332 17.6456 45.8332 18.7507V39.584C45.8332 40.6891 45.3942 41.7489 44.6128 42.5303C43.8314 43.3117 42.7716 43.7507 41.6665 43.7507H8.33317C7.2281 43.7507 6.16829 43.3117 5.38689 42.5303C4.60549 41.7489 4.1665 40.6891 4.1665 39.584V25.0007C4.1665 23.8956 4.60549 22.8358 5.38689 22.0544C6.16829 21.273 7.2281 20.834 8.33317 20.834Z"
                fill="white"
                stroke="#A1A1AA"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.5 10.4167V43.75H37.5V10.4167C37.5 9.3116 37.061 8.25179 36.2796 7.47039C35.4982 6.68899 34.4384 6.25 33.3333 6.25H16.6667C15.5616 6.25 14.5018 6.68899 13.7204 7.47039C12.939 8.25179 12.5 9.3116 12.5 10.4167Z"
                fill="white"
                stroke="#A1A1AA"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.8335 25H29.1668"
                stroke="#A1A1AA"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.8335 16.666H29.1668"
                stroke="#A1A1AA"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
